//Select Range

import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './MyCalendar.css'; // Import your custom CSS file
 
const MyCalendar = () => {
    const [dateRange, setDateRange] = useState([null, null]);
 
    const handleDateChange = (newDate) => {
        const [startDate, endDate] = dateRange;
 
        // If no start date is selected, set the start date
        if (!startDate) {
            setDateRange([newDate, null]);
        } else if (!endDate) {
            // If a start date is selected, set the end date
            if (newDate < startDate) {
                // If the new date is before the start date, update the start date
                setDateRange([newDate, startDate]);
            } else {
                setDateRange([startDate, newDate]);
            }
        } else {
            // Reset the selection if both dates are already selected
            setDateRange([newDate, null]);
        }
    };
 
    // Function to apply custom class to selected date range
    const tileClassName = ({ date }) => {
        const [startDate, endDate] = dateRange;
 
        if (startDate && endDate) {
            // Check if the date is within the selected range
            const isWithinRange = date >= startDate && date <= endDate;
            return isWithinRange ? 'highlight' : null;
        }
        return null;
    };
 
    return (
        <div>
            <h2>Select a Date Range</h2>
            <Calendar 
                onChange={handleDateChange} 
                value={dateRange[0] || dateRange[1] || new Date()} 
                tileClassName={tileClassName} // Apply custom class
            />
            <p>
                Selected Date Range: 
                {dateRange[0] && dateRange[1] 
                    ? `${dateRange[0].toDateString()} to ${dateRange[1].toDateString()}`
                    : ' Select a date range'
                }
            </p>
        </div>
    );
};
 
export default MyCalendar;